/* eslint-disable prettier/prettier */
import authModalTemplate from '../templates/authModal.html';
;
(function (ng) {
  'use strict';

  var AuthCustomCtrl = function ($http, toaster, $interval, modalService, $translate) {
    var ctrl = this;
    ctrl.secondCodeAmount = 30;
    ctrl.canSendSmsRu = false;
    ctrl.clickRegistartionBtn = false;
    ctrl.nextSendMesage = -1;
    ctrl.$onInit = function () {
      ctrl.zoneCity = '';
      ctrl.isProgress = true;
      document.addEventListener("isCheckoutCart", data => {
        ctrl.isCheckout = true;
      });
    };
    ctrl.loadVkBtn = className => {
      let elem = $(className);
      if ('VKIDSDK' in window) {
        const VKID = window.VKIDSDK;
        VKID.Config.init({
          app: 52046603,
          redirectUrl: 'https://chewhite.com/login',
          responseMode: VKID.ConfigResponseMode.Callback,
          source: VKID.ConfigSource.LOWCODE,
          scope: 'vkid.personal_info,user_id,email,phone' // Заполните нужными доступами по необходимости
        });

        const oAuth = new VKID.OAuthList();
        oAuth.render({
          container: elem[0],
          oauthList: ['vkid']
        }).on(VKID.WidgetEvents.ERROR, vkidOnError).on(VKID.OAuthListInternalEvents.LOGIN_SUCCESS, function (payload) {
          const code = payload.code;
          const deviceId = payload.device_id;
          VKID.Auth.exchangeCode(code, deviceId).then(vkidOnSuccess).catch(vkidOnError);
        });
        function vkidOnSuccess(data) {
          VKID.Auth.userInfo(data.access_token).then(res => {
            ctrl.user = {
              firstName: res.user.first_name,
              lastName: res.user.last_name,
              email: res.user.email,
              phone: res.user.phone,
              oAuthId: res.user.user_id
            };
            ctrl.authOpenIdVk();
          });
          // Обработка полученного результата
        }

        function vkidOnError(error) {
          console.log(data);

          // Обработка ошибки
        }
      }
    };

    ctrl.clickBtn = () => {
      let btnSend = $('.VkIdSdk_oauth_item[data-oauth="vkid"]');
      if (btnSend != undefined && btnSend.length > 0) {
        btnSend[0].click();
      }
    };
    ctrl.sendTelegramMessage = typeSend => {
      ctrl.errorWriteCode = false;
      ctrl.typeSend = typeSend !== null && typeSend !== void 0 ? typeSend : ctrl.typeSend;
      if (ctrl.phone == undefined || ctrl.phone.length != 16) {
        if (header.canSendSmsRu && !ctrl.typeSend) {
          toaster.pop('error', '', 'Не корректный номер телефона');
          return;
        }
      }
      if (ctrl.canNextCode) {
        if (ctrl.secondCodeAmount == 30) {
          ctrl.secondCodeAmount = 10;
        } else if (ctrl.secondCodeAmount == 60) {
          ctrl.secondCodeAmount = 10;
        }
      }
      ctrl.canNextCode = false;
      ctrl.viewError = false;
      $http.post('smsConfirmationClient/sendSmsCode', {
        phone: ctrl.phone,
        pageType: 'login',
        typeSender: ctrl.typeSend,
        //isTelegramSend ? 0 : 1,
        captchaCode: '',
        captchaSource: '',
        rnd: Math.random()
      }).then(function (response) {
        if (response.data.result) {
          console.log(ctrl.viewSeconds);
          ctrl.viewSeconds = ctrl.secondCodeAmount;
          $interval(() => {
            if (ctrl.viewSeconds != 0) ctrl.viewSeconds--;
            if (ctrl.viewSeconds == 0) {
              ctrl.canNextCode = true;
            }
          }, 1000, ctrl.secondCodeAmount);
          ctrl.viewBlockCode = true;
          if (ctrl.nextSendMesage >= 0 && ctrl.errorMessage != undefined && ctrl.errorMessage.length > 0) {
            ctrl.errorMessage = undefined;
            ctrl.nextSendMesage = -1;
          }
        } else {
          ctrl.errorMessage = response.data.msg;
          ctrl.nextSendMesage = 0;
          if (!ctrl.onlySendTelegram && response.data.onlySendTelegram && ctrl.canSendSmsRu) {
            ctrl.onlySendTelegram = response.data.onlySendTelegram;
            ctrl.canNextCode = true;
            //ctrl.sendTelegramMessage(true);
          }
        }
      });

      if (ctrl.typeSend == 0) ctrl.openLinkTelegram();
      if (ctrl.typeSend == 2) ctrl.openLinkMax();
      ctrl.selectedTypeSend = isTelegramSend;
    };
    ctrl.chekCode = () => {
      if (ctrl.code == undefined || ctrl.code == null || ctrl.code.length != 4) return;
      $http.post('smsConfirmationClient/ConfirmSmsCode', {
        phone: ctrl.phone,
        smsCode: ctrl.code,
        pageType: "login"
      }).then(function (response) {
        if (!response.data.result) {
          ctrl.errorWriteCode = true;
        } else {
          ctrl.errorWriteCode = false;
          ctrl.successCheckCode = true;
          if (response.data.type == "registration") {
            ctrl.viewBlockCode = false;
            ctrl.registrationUser = true;
            ctrl.user = {};
            ctrl.user.phone = ctrl.phone;
            ctrl.customerFields = response.data.customerField;
          } else {
            debugger;
            console.log(ctrl.isCheckout);
            if (ctrl.isCheckout) {
              location.replace('?viewCheckout=true');
              return;
            }
            location.replace('/myaccount');
          }
        }
      });
    };
    ctrl.openLinkTelegram = () => {
      $http.post('./BSSClient/GetLink', {
        phone: ctrl.phone
      }).then(res => {
        if (res.data.result) {
          window.open(res.data.url, '_blank');
        }
      });
    };
    ctrl.openLinkMax = () => {
      $http.post('./MBSClient/GetLink', {
        phone: ctrl.phone
      }).then(res => {
        if (res.data.result) {
          window.open(res.data.url, '_blank');
        }
      });
    };
    ctrl.createUser = () => {
      ctrl.clickRegistartionBtn = true;
      if (ctrl.user.lastName.length <= 2 || ctrl.user.email == undefined || ctrl.user.email == null || ctrl.inValidateEmail(ctrl.user.email)) {
        return;
      }
      if (ctrl.customerFields != null) {
        let gender = ctrl.customerFields.filter(cf => cf.Name === "Пол");
        if (gender != null && gender.length > 0) {
          let genderSelected = gender[0].Values.filter(v => v.Selected);
          if (genderSelected !== null && genderSelected.length > 0) {
            ctrl.user.CustomerFieldValue = genderSelected[0].Value;
            ctrl.user.CustomerFieldName = gender[0].Name;
          }
        }
      }
      $http.post('./SmsConfirmationClient/Registration', {
        model: ctrl.user
      }).then(res => {
        console.log(res);
        if (!res.data.result) {
          ctrl.clickRegistartionBtn = true;
          toaster.pop('error', '', res.data.errors[0]);
        } else {
          location.replace('/myaccount');
        }
      });
    };
    ctrl.openModalAuth = function () {
      let isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return;
      let windowDom = $('html.is-mobile.mobile-version');
      windowDom[0].style.overflowY = isOpen ? "hidden" : "scroll";
      if (isOpen) {
        windowDom[0].classList.add("auth-panel-active");
      } else {
        windowDom[0].classList.remove("auth-panel-active");
      }
    };
    ctrl.checkCanSendedSmsRu = () => {
      if (ctrl.phone == undefined || ctrl.phone.length != 16) {
        return;
      }
      $http.post('smsConfirmationClient/CanSendMethod', {
        phone: ctrl.phone,
        typeSender: 1,
        rnd: Math.random()
      }).then(function (response) {
        ctrl.canSendSmsRu = response.data;
      });
    };
    ctrl.authOpenIdVk = oAuthId => {
      $http.post('smsConfirmationClient/OAuthVk', {
        model: ctrl.user,
        rnd: Math.random()
      }).then(function (response) {
        if (!response.data.result) {
          ctrl.createUser();
        } else {
          location.replace('/myaccount');
        }
      });
    };
    ctrl.openAuthModal = () => {
      var options = {
        'modalClass': 'auth-dialog',
        //'callbackClose': callbackClose,
        'isOpen': true,
        'crossEnable': false
        //'isShowFooter': true,
        //'destroyOnClose': true
      };

      modalService.renderModal('modalAuthUser', null, "<div data-ng-include=\"'".concat(authModalTemplate, "'\"></div>"), null, options, {
        auth: ctrl
      });
      modalService.open('modalAuthUser');
    };
    ctrl.setSelected = (customerField, val) => {
      if (customerField.Values !== null && customerField.Values.length > 0) {
        customerField.Values.forEach((item, i, arr) => {
          item.Selected = item.Value === val.Value;
        });
      }
    };
    ctrl.getSelectedOption = customerField => customerField.Values.filter(v => v.Selected).map(v => v.Text).join(' ,');
    ctrl.checkWriteBirthDay = () => {
      let date = ctrl.user.birthday;
      if (date.length == 2 || date.length == 5) {
        date += '.';
      }
      if (date.length >= 2) {
        let dates = date.split('.');
        console.log(dates);
        if (dates.length > 0) {
          if (parseInt(dates[0]) > 31) {
            dates[0] = 31;
          }
          if (parseInt(dates[1]) > 12) {
            dates[1] = 12;
          }
          if (dates.length > 2 && parseInt(dates[2]) > 9999) {
            dates[2] = new Date().getFullYear();
          }
        }
        //if (dates.length == 3) {
        //    console.log(dates);
        //    if (dates[1].length == 0) {
        //        dates[1] = 1;
        //    }
        //    if (dates[0].length == 0) {
        //        dates[0] = 0;
        //    }

        //    let dateCustom = new Date(dates[2], parseInt(dates[1]) - 1, dates[0]);
        //    date = dateCustom.getDate() + '.' + (dateCustom.getMonth() + 1) + '.' + dates[2];
        //    console.log(dateCustom.getDate());
        //    console.log(dateCustom.getMonth());
        //    console.log(dateCustom.getFullYear());
        //}
        date = dates.join('.');
      }
      ctrl.user.birthday = date;
      console.log(ctrl.user.birthday);
    };
    ctrl.inValidateEmail = email => {
      let checkMails = String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      return checkMails === null || checkMails.length === 0;
    };
  };
  angular.module('zone').controller('AuthCustomCtrl', AuthCustomCtrl);
  AuthCustomCtrl.$inject = ['$http', 'toaster', '$interval', 'modalService', '$translate'];
})(window.angular);